/**
 *
 * @file 模型库store
 *
 **/

import { makeAutoObservable, flow } from 'mobx';
import { getFilterCondition, getAllCategory } from '&/api/modelBase';

const KEY_SET = ['collocationFilters'];

const CATG_KEY = 'hdccatgory';
const DEFAULT_CATG = sessionStorage.getItem(CATG_KEY)
    ? JSON.parse(sessionStorage.getItem(CATG_KEY))
    : [{}];
class ModelBase {
    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    // 分类信息管理
    allCategory = [
        { type: 1, children: [], labelKey: 'model' },
        { type: 2, children: [], labelKey: 'chartlet' },
        { type: 3, children: [], labelKey: 'material' },
    ];
    #isLoaded = false;
    // 一次性调用三次接口请求 分类信息管理数据
    queryAllCategory = flow(function* () {
        if (this.#isLoaded) return Promise.resolve();
        try {
            const { data } = yield getAllCategory();
            this.setAllCategory(data);
            this.#isLoaded = true;
            return Promise.resolve();
        } catch {
            return Promise.reject();
        }
    });

    setAllCategory({ chartlet_data = [], model_data = [], texture_data = [] }) {
        this.allCategory[0].children = model_data;
        this.allCategory[1].children = chartlet_data;
        this.allCategory[2].children = texture_data;
    }

    activeType = 1; // index
    activeCatgory = DEFAULT_CATG;

    setActiveType(val) {
        this.activeType = val;
    }
    setactiveCatgory(val) {
        if (!Array.isArray(val)) return;
        this.activeCatgory = val;
        sessionStorage.setItem(CATG_KEY, JSON.stringify(val));
    }

    // 模型搭配 筛选条件数据
    collocationFilters = [];

    /**
     * @desc 多个filter数据  公用的请求方法
     * @param {int} type '1：模型搭配，2：模型专题（，3：模型包，4：品牌模型'
     */
    queryCondition = flow(function* (type) {
        if (this[KEY_SET[type - 1]].length) return Promise.resolve();
        const { data } = yield getFilterCondition({ type });
        this.setCondition(data, type - 1);
    });

    // 多个filter数据  公用的赋值方法
    setCondition(data, idx) {
        this[KEY_SET[idx]] = data;
    }

    // 标记是否在模型搭配tab
    otherTabPath = '';

    setOtherTabPath(val) {
        this.otherTabPath = val;
    }
}

export default new ModelBase();
